import React from 'react';
import SectionHeader
  from '../SummarySubSections/SummarySubSection/SectionHeader/SectionHeader';
import Scroll from 'react-scroll';
import glossaryData from './glossaryData';
import s from './AttributeGlossary.less';

const AttributeGlossary = () => {
  //TODO: get full glossary

  const chunkIntoTwoCol = array => {
    const colHeight = Math.ceil (array.length / 2);
    return [array.slice (0, colHeight), array.slice (colHeight)];
  };

  const glossaryColumns = chunkIntoTwoCol (glossaryData);
  const attrAbbrString = glossaryItem => {
    if (glossaryItem.Abbreviation)
      return `${glossaryItem.Attribute} (${glossaryItem.Abbreviation})`;
    else return glossaryItem.Attribute;
  };

  return (
    <div className={`row ${s.glossary}`}>
      <div className={`col-xs-12`}>
        <div className={`shadowBox`}>
          <Scroll.Element
            name={'glossary'}
            id={'glossary'}
            style={{width: '100%'}}
          >
            <SectionHeader title={'Glossary'} />
          </Scroll.Element>
          <div className={`${s.itemList}`}>
            <dl className={`${s.itemColumn}`}>
              {glossaryColumns[0].map (item => {
                return (
                  <div
                    key={attrAbbrString (item)}
                    className={`${s.glossaryItem}`}
                  >
                    <dt className={`${s.attribute}`}>
                      {attrAbbrString (item)}
                    </dt>
                    <dd className={`${s.definition}`}>{item.Definition}</dd>
                  </div>
                );
              })}
            </dl>
            <dl className={`${s.itemColumn}`}>
              {glossaryColumns[1].map (item => {
                return (
                  <div
                    key={attrAbbrString (item)}
                    className={`${s.glossaryItem}`}
                  >
                    <dt className={`${s.attribute}`}>
                      {attrAbbrString (item)}
                    </dt>
                    <dd className={`${s.definition}`}>{item.Definition}</dd>
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttributeGlossary;



// WEBPACK FOOTER //
// ./src/components/AttributeGlossary/AttributeGlossary.js